define('shared/initializer/form/adapters/mixins/fields/util/addDropdownDefaultOption',['$'], function($){
    return function addDefaultOption($select, selectIt) {
        var ph = $select.attr('placeholder');
        var $opt;

        if (ph != null && ph !== '') {
            $opt = $(document.createElement('option'));
            $opt
                .attr('value', '')
                .text(ph);

            if (selectIt) {
                $opt.attr('selected', 'selected');
            }

            $opt.prependTo($select);
        }
    };
});
